<!-- 底部导航 -->
<template>
    <div>
        <div class="card">
            <div class="title">{{ newFormData.name }}</div>
        </div>
        <div class="card mb0">
            <Menu
                mode="horizontal"
                :active-name="name_id"
                @on-select="selectName"
            >
                <MenuItem name="1" class="head-text">底部导航</MenuItem>
                <MenuItem name="2" class="head-text">个人中心</MenuItem>
            </Menu>
            <div class="mt24 mb24">
                <div v-if="name_id == 1">
                    <Form
                        :model="newFormData.content"
                        label-position="right"
                        :label-width="111"
                    >
                        <div class="form-title">内容设置</div>
                        <FormItem label="选中文字颜色">
                            <ColorPicker
                                v-model="newFormData.content.txt_color"
                            />
                        </FormItem>
                        <FormItem label="未选中文字颜色">
                            <ColorPicker
                                v-model="newFormData.content.none_txt_color"
                            />
                        </FormItem>
                        <div class="flex-sb">
                            <div class="form-title">导航图标</div>
                            <div class="add-div" @click="addIcons">
                                <img class="add-img" src="@/assets/plus.png" />
                                <div class="add-txt">添加</div>
                            </div>
                        </div>
                        <div class="right-navs">
                            <div
                                class="right-nav"
                                v-for="(item, index) of newFormData.content
                                    .iconList"
                                :key="index"
                            >
                                <img
                                    class="del-img"
                                    src="@/assets/del.png"
                                    @click.stop="delIcons(index)"
                                />
                                <div style="display: flex">
                                    <div class="mt12 mr24">导航图标</div>
                                    <div
                                        class="right-uploads"
                                        @click="openModal('img_list', index)"
                                    >
                                        <img
                                            class="upload-img"
                                            v-if="item.img_list.picview"
                                            :src="item.img_list.picview"
                                        />
                                        <Icon
                                            v-else
                                            type="md-add"
                                            size="50"
                                            color="#C0C4CC"
                                        />
                                        <div class="upload-img-tip">
                                            选中图标
                                        </div>
                                    </div>
                                    <div
                                        class="right-uploads"
                                        @click="
                                            openModal('none_img_list', index)
                                        "
                                    >
                                        <img
                                            class="upload-img"
                                            v-if="item.none_img_list.picview"
                                            :src="item.none_img_list.picview"
                                        />
                                        <Icon
                                            v-else
                                            type="md-add"
                                            size="50"
                                            color="#C0C4CC"
                                        />
                                        <div class="upload-img-tip">
                                            未选中图标
                                        </div>
                                    </div>
                                </div>
                                <div style="flex: 1">
                                    <Input
                                        v-model="item.txt"
                                        placeholder="请输入图标文字"
                                    >
                                        <span slot="prepend">图标文字</span>
                                    </Input>
                                    <Select
                                        class="mt-6"
                                        v-model="item.action_id"
                                        filterable
                                        placeholder="跳转动作"
                                    >
                                        <Option
                                            v-for="item in actionList"
                                            :value="item.id"
                                            :key="item.id"
                                            >{{ item.name }}</Option
                                        >
                                    </Select>
                                    <Input
                                        class="mt-6"
                                        v-if="item.action_id == 1"
                                        v-model="item.link_name"
                                        placeholder="请输入外部链接（http/https）"
                                    ></Input>
                                    <Select
                                        class="mt-6"
                                        v-if="item.action_id == 2"
                                        v-model="item.link_id"
                                        filterable
                                        placeholder="请选择跳转页面"
                                    >
                                        <Option
                                            v-for="item in linkList"
                                            :value="item.id"
                                            :key="item.id"
                                            >{{ item.title }}</Option
                                        >
                                    </Select>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
                <div v-if="name_id == 2">
                    <Form
                        :model="newFormData.content"
                        label-position="right"
                        :label-width="100"
                    >
                        <div class="form-title">内容设置</div>
                        <FormItem label="文字颜色">
                            <ColorPicker
                                v-model="newFormData.content.txt_color2"
                            />
                        </FormItem>
                        <div class="flex-sb">
                            <div class="form-title">导航图标</div>
                            <div class="add-div" @click="addIcons2">
                                <img class="add-img" src="@/assets/plus.png" />
                                <div class="add-txt">添加</div>
                            </div>
                        </div>
                        <div class="right-navs">
                            <div
                                class="right-nav"
                                v-for="(item, index) of newFormData.content
                                    .iconList2"
                                :key="index"
                            >
                                <img
                                    class="del-img"
                                    src="@/assets/del.png"
                                    @click.stop="delIcons2(index)"
                                />
                                <div style="display: flex">
                                    <div class="mt12 mr24">导航图标</div>
                                    <div
                                        class="right-uploads"
                                        @click="openModal('img_list2', index)"
                                    >
                                        <img
                                            class="upload-img"
                                            v-if="item.img_list.picview"
                                            :src="item.img_list.picview"
                                        />
                                        <Icon
                                            v-else
                                            type="md-add"
                                            size="50"
                                            color="#C0C4CC"
                                        />
                                    </div>
                                </div>
                                <div style="flex: 1">
                                    <Input
                                        v-model="item.txt"
                                        placeholder="请输入图标文字"
                                    >
                                        <span slot="prepend">图标文字</span>
                                    </Input>
                                    <Select
                                        class="mt-6"
                                        v-model="item.action_id"
                                        filterable
                                        placeholder="跳转动作"
                                    >
                                        <Option
                                            v-for="item in actionList"
                                            :value="item.id"
                                            :key="item.id"
                                            >{{ item.name }}</Option
                                        >
                                    </Select>
                                    <Input
                                        class="mt-6"
                                        v-if="item.action_id == 1"
                                        v-model="item.link_name"
                                        placeholder="请输入外部链接（http/https）"
                                    ></Input>
                                    <Select
                                        class="mt-6"
                                        v-if="item.action_id == 2"
                                        v-model="item.link_id"
                                        filterable
                                        placeholder="请选择跳转页面"
                                    >
                                        <Option
                                            v-for="item in linkList"
                                            :value="item.id"
                                            :key="item.id"
                                            >{{ item.title }}</Option
                                        >
                                    </Select>
                                </div>
                            </div>
                        </div>
                        <div class="form-title">背景设置</div>
                        <FormItem label="背景颜色"
                            ><ColorPicker
                                v-model="newFormData.content.bg_color"
                        /></FormItem>
                        <FormItem label="背景图">
                            <i-switch
                                v-model="newFormData.content.bg_value"
                                size="large"
                                true-color="#FF761D "
                                :true-value="1"
                                :false-value="0"
                                @on-change="changeBgValue"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                        <FormItem
                            v-if="newFormData.content.bg_value"
                            label="上传背景"
                        >
                            <div class="bg-upload" @click="openModal('bg_img')">
                                <img
                                    class="bg-img"
                                    v-if="newFormData.content.bg_img.picview"
                                    :src="newFormData.content.bg_img.picview"
                                />
                                <Icon
                                    v-else
                                    type="md-add"
                                    size="30"
                                    color="#ccc"
                                />
                            </div>
                        </FormItem>
                    </Form>
                </div>
            </div>
        </div>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
export default {
    components: {
        pictureLibrary,
    },
    props: {
        diy_id: {
            type: String,
            default: "0",
        },
        newFormData: {
            type: Object,
            default: {},
        },
        linkList: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            srctype: "",
            select: 1,
            select_type: "image",
            switch_modal: false,
            actionList: [
                { id: 1, name: "跳转外部链接" },
                { id: 2, name: "跳转页面" },
                { id: 5, name: "跳转首页" },
                { id: 6, name: "跳转我的页面" },
                { id: 7, name: "跳转商城页面" },
            ],
            upload_index: "",
            name_id: "1",
        };
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            if (this.srctype == "bg_img") {
                for (var i = 0; i < param1.length; i++) {
                    this.newFormData.content.bg_img.picview = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.newFormData.content.bg_img.value = param2[i];
                }
            } else if (this.srctype == "img_list") {
                for (var i = 0; i < param1.length; i++) {
                    this.newFormData.content.iconList[this.upload_index].img_list.picview = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.newFormData.content.iconList[this.upload_index].img_list.value = param2[i];
                }
            } else if (this.srctype == "none_img_list") {
                for (var i = 0; i < param1.length; i++) {
                    this.newFormData.content.iconList[this.upload_index].none_img_list.picview = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.newFormData.content.iconList[this.upload_index].none_img_list.value = param2[i];
                }
            } else if (this.srctype == "img_list2") {
                for (var i = 0; i < param1.length; i++) {
                    this.newFormData.content.iconList2[this.upload_index].img_list.picview = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.newFormData.content.iconList2[this.upload_index].img_list.value = param2[i];
                }
            }
            this.$Message.destroy();
        },
        openModal(e, index) {
            this.switch_modal = true;
            this.srctype = e;
            this.upload_index = index;
        },
        // 删除
        delIcons(i) {
            if (this.newFormData.content.iconList.length == 1) {
                this.$Message.info("至少保留一张");
            } else {
                this.newFormData.content.iconList.splice(i, 1);
            }
        },
        delIcons2(i) {
            if (this.newFormData.content.iconList2.length == 1) {
                this.$Message.info("至少保留一张");
            } else {
                this.newFormData.content.iconList2.splice(i, 1);
            }
        },
        // 添加
        addIcons() {
            this.newFormData.content.iconList.push({
                txt: "底部导航",
                action_id: 1,
                link_id: 1,
                link_name: "",
                img_list: {
                    value: "/icon/diys/smail.png",
                    picview:
                        "https://suyuan.hulianzaowu.com/icon/diys/smail.png",
                },
                none_img_list: { value: "/icon/diys/smail.png", picview: "https://suyuan.hulianzaowu.com/icon/diys/smail.png" },
            });
        },
        addIcons2() {
            this.newFormData.content.iconList2.push({
                txt: "其他导航",
                action_id: 1,
                link_id: 1,
                link_name: "",
                img_list: {
                    value: "/icon/diys/smail.png",
                    picview:
                        "https://suyuan.hulianzaowu.com/icon/diys/smail.png",
                },
            });
        },
        changeBgValue(e) {
            this.newFormData.content.bg_value = e;
        },
        selectName(name) {
            this.name_id = name;
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
.right-navs {
    padding: 12px 12px 0 12px;
    width: 100%;
    border: 1px solid #c0c4cc;
}
.right-nav {
    margin-bottom: 12px;
    padding: 12px;
    border: 1px solid #c0c4cc;
    position: relative;
}
.del-img {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 99;
    cursor: pointer;
    width: 30px;
    height: 30px;
}
.right-uploads {
    margin: 0 24px 12px 0;
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 4px;
    position: relative;
}
.upload-img {
    width: 100%;
    height: 100%;
}
.mt-6 {
    margin: 6px 0 0 0;
}
.add-div {
    display: flex;
    cursor: pointer;
}
.add-img {
    width: 22px;
    height: 22px;
    margin-right: 6px;
}
.add-txt {
    font-size: 15px;
    color: #ff761d;
}
.bg-upload {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #ccc;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
}
.bg-img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
::v-deep .ivu-slider-bar {
    background-color: #ff761d;
}
::v-deep .ivu-slider-button {
    border: 2px solid #ff761d;
}
.report-div {
    margin: 12px 0;
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: center;
    position: relative;
    border: 1px solid #c0c4cc;
    cursor: pointer;
}
.report-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.del-reportimg {
    position: absolute;
    top: -10px;
    right: -10px;
    z-index: 99;
    width: 26px !important;
    height: 26px !important;
    cursor: pointer;
}
.report-txt {
    position: absolute;
    top: 80%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    font-size: 14px;
    color: #747b95;
}
.report-icon {
    position: absolute;
    font-size: 50px;
    color: #c0c4cc;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
}
.form-icon {
    position: absolute;
    top: -10px;
    left: 70px;
}

.upload-img-tip {
    background: rgba(49, 62, 74, 0.5);
    border-radius: 0px 0px 4px 4px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>